module.exports = __webpack_public_path__ + "img/gu.gu795bcfa.svg";